export default __webpack_public_path__ + "static/media/6R.ddda836b.png";